'use strict';
import angular from 'angular';
import _ from 'lodash';

angular.module('ioclusters.services', [])

    .factory('ClusterService', [
        'IORestangular',
        'CoreRestAngular',
        'ClusterFactory',
        'ColumnValueType',
        '$q',
        '$rootScope',
        '$timeout',
        function(
            IORestangular,
            CoreRestAngular,
            ClusterFactory,
            ColumnValueType,
            $q,
            $rs,
            $timeout
        ) {

            /************************************************************
             VARIABLES IN THE SERVICE
             ************************************************************/
            var service = {};
            var cluster = CoreRestAngular.service('clusters');
            var values = cluster.one('values');

            service.clusters = [];

            //storing All Business Units to prevent backend call for every page
            service.global = {
                allClusters: null,
                isAdmin: false
            };

            //all page related properties in this object
            service.pageProperties = {
                selectType: null,
                customClusters: null,
                optionalId: null,

                defaultClusters: null, //the default list of clusters the user provides.
                defaultClusterIds: null, //
                selectedClusters: null
            };

            // This variable is used to identify if select Type was changed when user navigates pages. This is especially useful when the user has chosen custom clusters and is navigation between single and multi select pages.
            service.selectTypeChanged = true;

            //saving user role in the service for reference
            service.userRole = null;

            //saving optionalID (cluster id override from page) in the service for reference
            service.optionalId = null;

            //this should be a part of the pageProperties, but keeping this outside for backward code compatibility
            service.clusterIds = null;



            var clusters = IORestangular.all('clusters');

            /************************************************************
             UTIL FUNCTIONS
             ************************************************************/

            var getClusters = function(params) {
                var deferred = $q.defer();
                IORestangular.all('clusters').getList(params).then(function(success) {
                    service.global.allClusters = success[0].clusters;
                    deferred.resolve();
                }, function(error) {
                    deferred.reject();
                });

                return deferred.promise;

            };

            // To Get clusters for non IO users
            service.getClustersForNonIO = function() {
                var deferred = $q.defer();
                IORestangular.all('clusters').getList().then(function(success) {
                    deferred.resolve(success);
                }, function(error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            }

            service.getFieldValues = function(fields) {
                return values.one(ColumnValueType.DISTINCT).get(_.isUndefined(fields) ? '' : { fields: fields });
            };

            var getDefaultClusters = function() {
                service.pageProperties.defaultClusters = [];
                service.pageProperties.defaultClusterIds = [];

                //looping to get the default cluster objects from cluster_ids
                if (service.userRole.cluster_ids && service.userRole.cluster_ids.length > 0) {
                    for (var x = 0; x < service.userRole.cluster_ids.length; x++) {
                        for (var i = 0; i < service.global.allClusters.length; i++) {
                            if (service.global.allClusters[i].id === service.userRole.cluster_ids[x]) {
                                service.pageProperties.defaultClusters.push(service.global.allClusters[i]);
                                service.pageProperties.defaultClusterIds.push(service.global.allClusters[i].id);
                                break;
                            }
                        }
                    };
                }
            };

            var setSelectedClusters = function() {
                //for compatibility
                if (service.optionalId.constructor == Array) {
                    service.clusterIds = service.optionalId;
                } else {
                    service.clusterIds = [service.optionalId];
                };

                service.pageProperties.selectedClusters = [];

                for (var x = 0; x < service.clusterIds.length; x++) {
                    for (var i = 0; i < service.global.allClusters.length; i++) {
                        if (service.global.allClusters[i].id == service.clusterIds[x]) {
                            service.pageProperties.selectedClusters.push(service.global.allClusters[i]);
                            break;
                        };
                    }
                };
            };


            service.clustersChangedInDirective = function(chosenClusters) {

                service.clusterIds = [];
                if (service.pageProperties.selectType == 'multiSelect' || service.pageProperties.selectType == 'multiSelectWithAllClusters') {
                    // Helper function to remove duplicates if any
                    chosenClusters = _.uniqBy(chosenClusters, function(e) {
                        return e.id;
                    });
                    var hasAllCluster = false;
                    for (var i = 0; i < chosenClusters.length; i++) {
                        if (chosenClusters[i].id === 0) {
                            service.clusterIds.push(chosenClusters[i].id);
                            hasAllCluster = true;
                            break;
                        }
                    }
                    if (hasAllCluster === false) {
                        for (var i = 0; i < chosenClusters.length; i++) {
                            service.clusterIds.push(chosenClusters[i].id);
                        }
                    }
                    service.pageProperties.selectedClusters = angular.copy(chosenClusters);
                } else { //singleSelect
                    service.clusterIds.push(chosenClusters.id);
                    service.pageProperties.selectedClusters = [];
                    service.pageProperties.selectedClusters = angular.copy(chosenClusters);
                }
                // service.clusterIds = userRole.cluster_ids;
                if (service.clusterIds.length) {
                    $rs.$broadcast('ClusterChanged');
                }

                $rs.$broadcast('selectedClustersChanged')
            };

            /*************************************************************
             CLUSTER SERVICE FLOW.
             *************************************************************/


            var step3_calcSelectedClusters = function(deferred) {
                if (!service.pageProperties.defaultClusters) {
                    //only calculate once. Default remains the same. No need to recalculate
                    getDefaultClusters();
                }

                if (service.optionalId) { //if optional id is present set cluster to show as that.
                    setSelectedClusters();
                } else if (service.selectTypeChanged || !service.clusterIds) { //if no optional id

                    if (service.global.isAdmin) {
                        //here we just show the default clusters defined for his role.
                        // If user is navigating from multi to single and vice-versa, we need to remember the cluster Id and populate it
                        if (_.isNull(service.clusterIds)) {
                            service.clusterIds = angular.copy(service.pageProperties.defaultClusterIds);
                            if (service.pageProperties.selectType == 'multiSelectWithAllClusters' || service.pageProperties.selectType === 'multiSelect') {
                                service.pageProperties.selectedClusters = angular.copy(service.pageProperties.defaultClusters);
                            } else {
                                service.pageProperties.selectedClusters = angular.copy(service.pageProperties.defaultClusters[0]);
                            }
                        } else {
                            switch (service.pageProperties.selectType) {

                                case 'multiSelectWithAllClusters':
                                    if (!service.pageProperties.selectedClusters.length) {
                                        service.pageProperties.selectedClusters = [service.pageProperties.selectedClusters];
                                    }
                                    break;
                                case 'singleSelectWithAllClusters':
                                case 'singleSelect':
                                    if (service.pageProperties.selectedClusters.length && service.pageProperties.selectedClusters[0].id == 0) {
                                        service.pageProperties.selectedClusters = angular.copy(service.pageProperties.defaultClusters[0]);
                                    } else if (service.pageProperties.selectedClusters.length) {
                                        service.pageProperties.selectedClusters = service.pageProperties.selectedClusters[0];
                                    }
                                    break;
                            };
                            if (service.pageProperties.selectedClusters) {
                                service.clusterIds = [];
                                if (service.pageProperties.selectedClusters.length) {
                                    service.clusterIds.push(service.pageProperties.selectedClusters[0].id);
                                } else {
                                    service.clusterIds.push(service.pageProperties.selectedClusters.id);
                                }
                            }
                        }

                    } else {
                        //since this was calculated using role/cluster_ids
                        // service.pageProperties.selectedClusters determine which clusters will display in the selector
                        if (service.pageProperties.selectType == 'multiSelectWithAllClusters' || service.pageProperties.selectType === 'multiSelect') {
                            service.pageProperties.selectedClusters = service.pageProperties.customClusters;
                        } else {
                            if (!service.pageProperties.selectedClusters || service.pageProperties.selectedClusters.length == 0) {
                                service.pageProperties.selectedClusters = service.pageProperties.customClusters[0];
                            } else {
                                service.pageProperties.selectedClusters = service.pageProperties.selectedClusters[0];
                            }
                        }

                        // Vendor logins don't have any clusters, so we need to check for that
                        // service.clusterIds determine which order form will display
                        if (service.pageProperties.customClusters.length && service.pageProperties.customClusters[0]) {
                            if (service.pageProperties.selectType == 'multiSelectWithAllClusters' || service.pageProperties.selectType === 'multiSelect') {
                                service.clusterIds = [];
                                _.each(service.pageProperties.customClusters, function(cluster) {
                                    service.clusterIds.push(cluster.id);
                                });
                            } else {
                                if (!service.pageProperties.selectedClusters || service.pageProperties.selectedClusters.length == 0) {
                                    service.clusterIds = [service.pageProperties.customClusters[0].id];
                                } else {
                                    service.clusterIds = [service.pageProperties.selectedClusters.id];
                                }
                            }
                        }
                    }
                }


                //if no clusters were found
                if (!service.pageProperties.selectedClusters || service.pageProperties.selectedClusters.length == 0) {
                    if (service.pageProperties.selectType == 'multiSelectWithAllClusters' || service.pageProperties.selectType === 'multiSelect') {
                        service.pageProperties.selectedClusters.push(service.pageProperties.customClusters[0]);
                    } else {
                        service.pageProperties.selectedClusters = service.pageProperties.customClusters[0];
                    }
                    service.clusterIds = [];

                    // Vendor logins don't have any clusters, so we need to check for that
                    if (service.pageProperties.customClusters.length && service.pageProperties.customClusters[0]) {
                        service.clusterIds.push(service.pageProperties.customClusters[0].id);
                    }
                }


                $timeout(function() {
                    $rs.$broadcast('initPageCluster', { type: service.pageProperties.selectType });
                    $rs.$broadcast('ClusterChanged');
                    $rs.$broadcast('selectedClustersChanged')
                }, 500);

                // Sometimes we need to init page cluster when cluster selector tells us it is ready
                $rs.$on('clusterSelectorReady', function(event, args) {
                    $rs.$broadcast('initPageCluster', { type: service.pageProperties.selectType });
                    $rs.$broadcast('ClusterChanged');
                    $rs.$broadcast('selectedClustersChanged')
                });
                deferred.resolve();

            };

            var step2_setClusters = function(deferred) {


                var userAccessableClusters = [];

                if (service.global.isAdmin) {

                    userAccessableClusters = angular.copy(service.global.allClusters);

                    switch (service.pageProperties.selectType) {

                        case 'multiSelectWithAllClusters':
                            userAccessableClusters.unshift({ id: 0, name: 'All Business Units' });
                            break;
                        case 'multiSelect':
                            //do nothing
                            break;

                        case 'singleSelectWithAllClusters':
                            userAccessableClusters.unshift({ id: 0, name: 'All Business Units' });
                            break;

                        case 'singleSelect':
                            //do nothing
                            break;
                    };

                } else { // not an admin

                    if (service.pageProperties.selectType == 'multiSelectWithAllClusters') {
                        service.pageProperties.selectType = 'multiSelect';
                    } else if (service.pageProperties.selectType == 'singleSelectWithAllClusters') {
                        service.pageProperties.selectType = 'singleSelect';
                    };

                    for (var x = 0; x < service.userRole.cluster_ids.length; x++) {
                        for (var i = 0; i < service.global.allClusters.length; i++) {
                            if (service.global.allClusters[i].id === service.userRole.cluster_ids[x]) {
                                userAccessableClusters.push(service.global.allClusters[i]);
                                break;
                            }
                        }
                    };
                    userAccessableClusters = _.sortBy(userAccessableClusters, function (i) { return i.name.toLowerCase(); });
                };


                service.pageProperties.customClusters = userAccessableClusters;
                service.clusters = userAccessableClusters;
                step3_calcSelectedClusters(deferred);


            };


            /*
                START POINT FOR THE CLUSTER SERVICE
                Three distinct steps happen here.
                initCluster - gathering of cluster requirements defined by the page and userRole
                step2_setClusters - setting up the list of All Business Units user is allowed to access
                step3_calcSelectedClusters - setting up the chosen clusters the user is currently viewing either by default or by his own choice (through the directive)
            */
            service.initCluster = function(userRole, selectType, optionalId) {
                $rs.showClusters = false;
                var deferred = $q.defer();
                service.userRole = userRole;
                service.optionalId = optionalId;

                //operations on selectType
                if (!selectType) {
                    selectType = 'singleSelectWithAllClusters';
                };

                if (selectType == 'disabled') {
                    service.pageProperties.isDisabled = true;
                    selectType = 'multiSelectWithAllClusters';
                } else {
                    service.pageProperties.isDisabled = false;
                }

                //If select type has not changed then don't recalculate selectedClusters and selectedClusterIds
                //This is useful when we user has chosen clusters and we move from single select page to multi select page or vice versa
                if (service.pageProperties.selectType == selectType) {
                    service.selectTypeChanged = false;
                } else {
                    service.selectTypeChanged = true;
                }

                service.pageProperties.selectType = selectType;



                if (service.userRole.permissions == 'superadmin' || service.userRole.permissions == 'adops,admin') {
                    service.global.isAdmin = true;
                } else {
                    service.global.isAdmin = false;
                }

                //Start with step 2. If we already called allClusters, no need to recall.
                if (service.global.allClusters) {
                    step2_setClusters(deferred);

                } else {
                    getClusters().then(function(success) {
                        step2_setClusters(deferred);
                    }, function(error) {})
                }


                return deferred.promise;
            };



            return service;

        }
    ])
    .factory('ClusterFactory', ['$resource', 'AppConfig', function($resource, AppConfig) {
        var factory = {};
        factory.clusters = function() {
            return $resource(AppConfig.IO_API_URL + 'clusters', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };
        return factory;
    }]);